/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getCompanyData,
  getPlansByCompanyId,
} from "../features/company/companySlice";
import {
  addEmployeePlan,
  cancelEmployeeHmoPlan,
  deleteEmployee,
  getEmployeeData,
  getEmployees,
  openModal,
  setPagination,
} from "../features/company/employeeSlice";
import config from "../utils/config";
import Menu from "../utils/data.dropdown";
import { capitalize, getIds } from "../utils/helper";

const { routes } = config;

export default function UseEmployee() {
  const { employees, pagination, loading, modal, model } =
      useSelector(getEmployeeData),
    { plans } = useSelector(getCompanyData),
    [name, setName] = useState("this user"),
    [cancelPlanPayload, setCancelPlanPayload] = useState(""),
    navigate = useNavigate(),
    dispatch = useDispatch();

  useEffect(() => {
    let cb = () => {};
    if (pagination.search) {
      dispatch(setPagination({ page: 1 }));
      cb = setTimeout(
        (_) => (async () => await dispatch(getEmployees(getIds().company)))(),
        700
      );
    } else cb = (async () => await dispatch(getEmployees(getIds().company)))();

    return () => {
      clearTimeout(cb);
    };
  }, [pagination.search, pagination.page]);

  let data = employees?.map((employee) => ({
    Name: employee?.User?.firstName + " " + employee?.User?.lastName,
    "Employee ID": employee?.employeeId || "N/A",
    Email: employee?.User?.email || "N/A",
    "Phone Number": employee?.User?.phoneNumber || "N/A",
    "H.M.O Plan": capitalize(employee?.companyuserplans?.name) || "N/A",
    status: employee?.User?.verified ? "Active" : "Inactive",
    _data: employee,
  }));

  const menu = new Menu({});
  const dropdownMenu = [
    menu.view({
      navigate,
      route: routes.companies.employees.employee,
    }),
    menu.viewEmployeeConsultations({
      navigate,
      routes,
    }),
    menu.edit({
      navigate,
      route: routes.companies.employees.employee,
    }),
    menu.cancelPlan({
      action: (value) => {
        setName(`${value?.User?.firstName}  ${value?.User?.lastName}`);

        setCancelPlanPayload({
          employeeUserId: value.userId,
          planId: value.planId,
          companyId: value?.companyId,
        });
        dispatch(openModal("cancelPlan"));
      },
      route: routes.companies.employees.employee,
    }),
    menu.addEmployeePlan({
      action: (value) => {
        setName(`${value?.User?.firstName}  ${value?.User?.lastName}`);

        setCancelPlanPayload({
          employeeUserId: value.userId,
          companyId: value?.companyId,
        });
        dispatch(openModal("addPlan"));
      },
    }),
    menu.delete({
      action: (value) => {
        setCancelPlanPayload({
          employeeId: value.userId,
          companyId: value?.companyId,
        });

        setName(`${value?.User?.firstName}  ${value?.User?.lastName}`);
        dispatch(openModal("delete"));
      },
    }),
  ];
  const cancelHmoPlan = () => {
    dispatch(cancelEmployeeHmoPlan(cancelPlanPayload));
  };

  const handleDelete = async () => {
    const res = await dispatch(deleteEmployee(cancelPlanPayload)).unwrap();
    res?.success === true && dispatch(getEmployees(getIds().company));
  };

  const addHmoPlan = async () => {
    const plan = plans?.find(({ Plan, planId }) => {
      return model.hmoPlan.includes(Plan.name) ? planId : "";
    });

    const res = await dispatch(
      addEmployeePlan({ ...cancelPlanPayload, planId: plan.planId })
    ).unwrap();
    res?.success && dispatch(getEmployees(cancelPlanPayload.companyId));
  };

  useEffect(() => {
    dispatch(
      getPlansByCompanyId({ isActive: true, companyId: getIds().company })
    );
  }, []);

  return {
    data,
    pagination,
    loading,
    dropdownMenu,
    modal,
    name,
    cancelHmoPlan,
    handleDelete,
    addHmoPlan,
    cancelPlanPayload,
    model,
    dispatch,
    plans,
  };
}
